import { useSelector } from 'react-redux';
import { PBAItem } from '../../redux/localReports/localReports.proptype';
import { selectPBAsListBySelectedTransactions } from '../../selectors';

export const useSelectPBAsListBySelectedTransactions = (): PBAItem[] => {
  const pbaList = useSelector(selectPBAsListBySelectedTransactions);

  return pbaList;
};
